"use client";

import parse, { domToReact, HTMLReactParserOptions } from "html-react-parser";
import { CheckCircle2 } from "lucide-react";

interface Props {
  content?: string;
  className?: string;
}

export default function RichText({ content = "", className = "" }: Props) {
  const options: HTMLReactParserOptions = {
    replace: (node: any) => {
      if (!node.name) return;
      if (node.attribs?.style) {
        delete node.attribs.style;
      }

      if (node.name === "p") {
        return (
          <p className="text-base text-brand-bg leading-relaxed 3xl:text-lg">
            {domToReact(node.children, options)}
          </p>
        );
      }
      if (node.name === "strong") {
        return (
          <strong className="text-brand-bg font-semibold 3xl:text-lg">
            {domToReact(node.children, options)}
          </strong>
        );
      }
      if (node.name === "ul") {
        return (
          <ul className="space-y-3 my-4 3xl:text-lg">
            {domToReact(node.children, options)}
          </ul>
        );
      }
      if (node.name === "ol") {
        return (
          <ol className="space-y-3 my-4 3xl:text-lg">
            {domToReact(node.children, options)}
          </ol>
        );
      }

      if (node.name === "li") {
        const parent = node.parent?.name;

        return (
          <li className="flex items-center gap-3 text-base text-brand-bg 3xl:text-lg">
            {parent === "ul" ? (
              <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full  ring-1 ring-brand-card">
                <CheckCircle2 className="h-3 w-3 text-brand-card" />
              </span>
              
            ) : (
              <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full  ring-1 ring-brand-card">
                <CheckCircle2 className="h-3 w-3 text-brand-card" />
              </span>
            )}
            <span>{domToReact(node.children, options)}</span>
          </li>
        );
      }
    },
  };

  return (
    <div className={`prose prose-invert text-base text-brand-bg leading-relaxed 3xl:text-lg mb-5 ${className}`}>
      {parse(content, options)}
    </div>
  );
}